/**
 * Navigate while preserving brand context in URL query params.
 *
 * Reads brandUuid from current URL first, falls back to localStorage.
 * This ensures brand context survives across page transitions even on
 * Vercel preview URLs where subdomain detection doesn't work.
 */
import { getHubBrand } from '@/store';

export const navigateWithBrand = (router, path, options = {}) => {
  const brandUuid = router.query?.brandUuid || (typeof window !== 'undefined' && (getHubBrand().uuid ?? null));
  const query = { ...(brandUuid ? { brandUuid } : {}), ...(options.query || {}) };
  return router.push({ pathname: path, query }, undefined, options);
};

/**
 * Returns true for preview/CI hostnames where subdomain extraction
 * would produce garbage brand codes (Vercel deployments, Render services).
 */
export const isPreviewHost = (host) =>
  Boolean(host?.endsWith('.vercel.app') || host?.endsWith('.onrender.com'));
